import { connect, ConnectedProps } from 'react-redux'

import { hideNavigation } from 'redux/actions'
import NavFile from 'components/layout/mobile-menu/NavFile'
import { AppDispatch } from 'redux/store'

const mapDispatchToProps = (dispatch: AppDispatch): { hideNavigation: () => ReturnType<AppDispatch> } => ({
  hideNavigation: () => dispatch(hideNavigation())
})

const connector = connect(null, mapDispatchToProps)

export type NavFileContainerProps = ConnectedProps<typeof connector>

export default connect(null, mapDispatchToProps)(NavFile)
